import { values } from "lodash";

export const answer_type_with_result = [
  "text",
  "date",
  "text-optional",
  "number_or_none",
];

export const remove_form_multi_choice = [
  "I am not sure",
  "None",
  "None of the above",
];

export const PAQAssessmentSortQuestion = [240, 246, 251, 252, 266, 273, 274];
